module.exports = require("lodash/clone");